'use client';

import './search-results.scss';

import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { z } from 'zod';

import { SearchBar } from '../../molecules/search-bar/search-bar';
import { getLegacyQuery, useUrlState } from '../../utils/search';
import { SearchResultsList } from './search-results-list';

const SearchResultsSchema = z.object({
  q: z.string().optional(),
  page: z.coerce.number().int().nonnegative().catch(0).optional(),
});

export type SearchResultsSchema = z.infer<typeof SearchResultsSchema>;

export const SearchResults = () => {
  const { t } = useTranslation();
  const { filters, updateSearchParams } = useUrlState(SearchResultsSchema);
  const itemsPerPage = 10;

  const handlePageChange = (page: number) => {
    updateSearchParams({ page: page.toString() });
  };

  const handleQueryChange = (query: string) => {
    updateSearchParams({ q: query, page: '0' });
  };

  // The legacy search uses a fragment like #stq=kenya.
  // That page will be redirected here, so if the query exists, let's use it.
  useEffect(() => {
    const legacyQuery = getLegacyQuery();
    if (legacyQuery) {
      handleQueryChange(legacyQuery);
    }
  }, []);

  return (
    <section className="SearchResults component">
      <div className="SearchResults__container container">
        <SearchBar
          title={t('skippy.siteSearch.searchResults')}
          titleSize="lg"
          placeholder={t('skippy.siteSearch.searchOurSite')}
          onQueryChange={(value) => handleQueryChange(value)}
          defaultQuery={filters.searchQuery}
          enableQuickSearch
        />
        <SearchResultsList
          queryText={filters.searchQuery}
          itemsPerPage={itemsPerPage}
          currentPage={filters.currentPage}
          onPageChange={(page) => handlePageChange(page)}
        />
      </div>
    </section>
  );
};
